import React, { SyntheticEvent } from 'react'
import Link from 'next/link'

const new_card_span_img = require('../public/static/new-card-span.svg')
const vertical_slash_line_img = require('../public/static/vertical-slash-line.png')
interface ListedItem {
  series_id: number
  series_name: string
  price: string
  online_date: string
  cover_url: string
  series_type: string
  onClick?: (e: SyntheticEvent) => void
}
export default function NewCarCard(props: ListedItem) {
  const {
    series_id,
    series_name,
    price,
    online_date,
    cover_url,
    series_type,
    onClick,
  } = props
  const car_profile_url = `/auto/series/${series_id}`
  return (
    <div className="card-container">
      <span className="release-date">
        <span className="inside-date">{online_date.slice(0, -2)}</span>
      </span>
      <div className="card" onClick={onClick}>
        <Link href={car_profile_url}>
          <a target="_blank">
            <span className="car-name">{series_name}</span>
          </a>
        </Link>
        <span className="car-category">{series_type}</span>
        <span className="car-price-label">
          指导价：
          <Link href={car_profile_url}>
            <a target="_blank">
              <span className="car-price">{price}</span>
            </a>
          </Link>
        </span>
        <Link href={car_profile_url}>
          <a target="_blank">
            <img src={cover_url} alt="car_img_here" />
          </a>
        </Link>
      </div>

      <style jsx>
        {`
        .card-container{
          width: 380px;
          margin-bottom: 20px;
          white-space: nowrap;
        }
        .release-date{
          position: relative;
          display: inline-block;
          height: 24px;
          width: 77px;
          border-radius: 2px 0 0 2px; 
          -webkit-background-clip: padding-box; /* Used to remove vertical line on the right side.*/
          background-image: url("${new_card_span_img}");
          background-repeat: no-repeat;
          vertical-align: top;
        }
        .release-date::after{
          position: absolute;
          right: 9px;
          top: 24px;
          content: url('${vertical_slash_line_img}');
          width: 1px;
          height: 88px;
        }
        .inside-date{
          margin: 4px auto 3px 8px;
          display: inline-block;
          text-align: center;
          font-size: 12px;
          line-height: 17px;
          height: 17px;
          color: white;
        }
        .card{
          position: relative;
          display: inline-block;
          margin-left: 4px;
          height: 96px;
          width: 299px;
          border-radius: 2px;
          background-color: #f7f8fc;
          padding: 12px;
        }
        .car-name{
          display: inline-block;
          font-size: 18px;
          font-weight: 500;
          color: #1f2129;
          margin-bottom: 4px;
          cursor: pointer;
          max-width: 159px;
          text-overflow: ellipsis;
          word-break: break-all;
          white-space: nowrap;
          overflow: hidden;
        }
        .car-name:hover{
          color: #e65800;
        }
        .car-category{
          display: block;
          color: #606370;
          font-size: 14px;
          margin-bottom: 4px;
          max-width: 159px;
          text-overflow: ellipsis;
          word-break: break-all;
          white-space: nowrap;
          overflow: hidden;
        }
        .car-price-label{
          display: block;
          font-size: 14px;
          color: #606370;
        }
        .car-price{
          color: #e62021;
          cursor: pointer;
        }
        .car-price:hover{
          text-decoration: underline;
        }
        .card img{
          position: absolute;
          width: 108px;
          height: 72px;
          right: 12px;
          bottom: 12px;
          cursor: pointer;
          transition: transform .3s ease-in-out;
        }
        .card img:hover{
          transform: scale(1.1);
        }
      `}
      </style>
    </div>
  )
}
